import React, { useMemo } from 'react';
import { AttachmentTray, fromMessageAttachments } from '@components/Attachments';
import { MessageAttachments } from './Chat.styled';
import type { MessageAttachment } from '@hooks/useChat';

const FileAttachments: React.FC<{
  attachments?: MessageAttachment[];
  role: 'user' | 'assistant';
}> = ({ attachments, role }) => {
  const items = useMemo(() => fromMessageAttachments(attachments ?? []), [attachments]);

  if (items.length === 0) return null;

  return (
    <MessageAttachments $role={role}>
      <AttachmentTray items={items} align={role === 'user' ? 'end' : 'start'} />
    </MessageAttachments>
  );
};

export default FileAttachments;
